import { useQuery } from 'react-query'
import { fiveMinutesInMiliseconds } from 'src/config/constants'
import { getDistrictsForSelectedTreatment } from 'src/services/api/clinic'
import { useTreatmentPurpose } from './useTreatmentPurpose'
import { useIsAllClinicsVariant } from './useIsAllClinicsVariant'

export const useDistricts = () => {
  const treatmentPurposeId = useTreatmentPurpose()
  const isAllClinicsVariant = useIsAllClinicsVariant()

  const result = useQuery(
    ['districts', treatmentPurposeId],
    () => getDistrictsForSelectedTreatment(treatmentPurposeId!),
    {
      retry: 3,
      enabled: !!treatmentPurposeId && isAllClinicsVariant,
      staleTime: fiveMinutesInMiliseconds,
    }
  )

  return result
}
